import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';

import { form as formStyle } from '@/styles';

const ChartDescriptionTile = ({ chart }) => {
  const { chartTitle, chartDescription } = chart;

  return (
    <div css={formStyle.gridCol}>
      <div>{chartTitle}</div>
      <div>{chartDescription}</div>
    </div>
  );
};

ChartDescriptionTile.propTypes = {
  chart: PropTypes.object.isRequired,
};

export default ChartDescriptionTile;
